export default class HeaderController {
	constructor() {
		this.headerElement = null;
		this.menuButton = null;
		
		this.panelContainer = null;
		this.panels = [];
		this.activePanel = null;

		this.previousScroll = 0;
		this.scrollCounter = 0;
		this.threshold = 500;

		this.init();
		this.resize();
	}

	init() {
		this.headerElement = document.querySelector('header');
		this.menuButton = this.headerElement.querySelector('.menuButton');
		this.previousScroll = window.pageYOffset;

		this.panelContainer = document.querySelector('.menuPanels');
		this.panelContainer.querySelectorAll('.panel').forEach(panel => this.panels.push(panel));

		// Register events
		// window.app.registerResizeEvent(this.resize.bind(this));
		// window.app.registerScrollEvent(this.scroll.bind(this));

		// Click events
		this.headerElement.querySelectorAll('[data-panel-opens]').forEach(panelOpener => {
			let panelId = panelOpener.dataset.panelOpens;
			if (this.panels.map(panel => panel.dataset.panel).includes(panelId)) {
				panelOpener.addEventListener('click', e => {
					e.preventDefault();
					this.openPanel(panelId);
				});
			}
		});
		this.panels.forEach(panel => {
			panel.querySelectorAll('[data-panel-opens]').forEach(panelOpener => {
				let panelId = panelOpener.dataset.panelOpens;
				if (this.panels.map(panel => panel.dataset.panel).includes(panelId)) {
					panelOpener.addEventListener('click', e => {
						e.preventDefault();
						this.openPanel(panelId);
					});
				}
			});

			panel.querySelectorAll('button.closePanel, [data-panel-close]').forEach(button => button.addEventListener('click', this.closePanels.bind(this)));
		});

		window.addEventListener('keydown', e => {
			if (e.key && e.key.substr(0, 3).toLowerCase() == 'esc' && document.documentElement.classList.contains('menuOpened')) {
				this.closePanels();
			}
		});
	}

	openPanel(panelId) {
		const activatePanel = panel => {
			panel.classList.add('active');
			panel.classList.add('replacer');
			document.documentElement.classList.add('menuOpened');
			document.documentElement.classList.add('disableScrollMenu');
			this.panelContainer.classList.add('panelActive');
		}
		this.panels.forEach(panel => {
			panel.querySelectorAll('[data-panel-opens]').forEach(link => {
				link.classList.remove('panelActive');
			});
			panel.querySelectorAll(`[data-panel-opens="${panelId}"]`).forEach(link => {
				link.classList.add('panelActive');
			});
		});

		this.headerElement.querySelectorAll('[data-panel-opens]').forEach(link => {
			link.classList.remove('panelActive');
		});
		this.headerElement.querySelectorAll(`[data-panel-opens="${panelId}"]`).forEach(link => {
			link.classList.add('panelActive');
		});
		let panel = this.panels.filter(panel => panel.dataset.panel == panelId)[0];
		// debugger;
		if (panel) {
			if (!panel.classList.contains('active')) {
				// Open panel
				let activePanels = this.panels.filter(panel => panel.classList.contains('active'));
				if (activePanels.length) {
					activePanels.forEach(panel => {
						panel.classList.add('replacing');
						panel.classList.remove('active');
						panel.classList.remove('replacer');

						setTimeout(() => {
							panel.classList.remove('replacing');
						}, app.animationDuration);
					});
					activatePanel(panel);
				} else {
					activatePanel(panel);
				}
			} else {
				// Close panel
				panel.classList.remove('active');
				document.documentElement.classList.remove('menuOpened');
				document.documentElement.classList.remove('disableScrollMenu');		
				panel.classList.remove('replacer');

				this.panels.forEach(panel => {
					panel.querySelectorAll('.panelActive').forEach(link => {
						link.classList.remove('panelActive');
					});
				});
		
				this.headerElement.querySelectorAll('.panelActive').forEach(link => {
					link.classList.remove('panelActive');
				});
				this.panelContainer.classList.remove('panelActive');
			}
		}	
	}

	closePanels() {
		this.panels.forEach(panel => {
			panel.classList.remove('replacing');
			panel.classList.remove('replacer');
			panel.classList.remove('active');
		});
		document.documentElement.classList.remove('menuOpened');
		document.documentElement.classList.remove('disableScrollMenu');

		this.panels.forEach(panel => {
			panel.querySelectorAll('.panelActive').forEach(link => {
				link.classList.remove('panelActive');
			});
		});

		this.headerElement.querySelectorAll('.panelActive').forEach(link => {
			link.classList.remove('panelActive');
		});

		this.panelContainer.classList.remove('panelActive');
	}

	toggleSubMenu(button) {
		if (button.parentNode.querySelector('ul.submenu')) {
			button.classList.toggle('active');
		}
	}

	resize() {
		this.previousScroll = window.pageYOffset;
		this.threshold = this.headerElement.clientHeight;

		this.scroll();
	}

	scroll() {
		// First, decide if it's up or down
		if (this.previousScroll > window.pageYOffset) {
			// Up
			if (this.scrollCounter > 0) {
				this.scrollCounter = 0;
			}

			this.scrollCounter += window.pageYOffset - this.previousScroll;
		} else if (this.previousScroll < window.pageYOffset) {
			// Down
			if (this.scrollCounter < 0) {
				this.scrollCounter = 0;
			}

			this.scrollCounter += window.pageYOffset - this.previousScroll;
		}

		if (window.pageYOffset < this.threshold) {
			this.show();
		} else {
			if (this.scrollCounter > this.threshold) {
				this.hide();
			}
	
			if (this.scrollCounter < this.threshold * -1) {
				this.show();
			}
		}

		this.previousScroll = window.pageYOffset;
	}

	hide() {
		this.headerElement.classList.add('hidden');
	}

	show() {
		this.headerElement.classList.remove('hidden');
	}
}